export enum EditModes {
  EditDay = 'day',
  EditTimeWindow = 'window',
  EditLocation = 'location',
  EditTimeSlot = 'slot',
}
